/**
 * @(#)2020/6/18.
 * Extend 纯净无污染组件，适合扩展自定义组件
 * @author 修言
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import Basics from "./Basics";
import { cloneDeep } from "./../../utils";
import { YxComponent, Connection } from "./../YxComponent";

let defaul = () => {
  return {
    inputParam: {},
    children: "", //子节点
    getFieldDecoratorParam: {},
  };
};

@Connection(defaul)
export default class extends YxComponent {
  constructor(props, content) {
    super(props, content);
  }

  productionHtml = (props) => {
    let html = Basics.html(props);
    return html;
  };

  render() {
    const props = { ...this.props };
    const Html = this.productionHtml(props);
    return Html;
  }
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxExtend.js